import { render, staticRenderFns } from "./image.vue?vue&type=template&id=1bef100c&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bef100c')) {
      api.createRecord('1bef100c', component.options)
    } else {
      api.reload('1bef100c', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=1bef100c&", function () {
      api.rerender('1bef100c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/image.vue"
export default component.exports